import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankService } from '../../services/bank.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sanction-loan-dialogue',
  templateUrl: './sanction-loan-dialogue.component.html',
  styleUrls: ['./sanction-loan-dialogue.component.scss'],
})
export class SanctionLoanDialogueComponent implements OnInit {
  loanType: any = [
    { id: 1, value: 'Cash Credit Loan' },
    { id: 2, value: 'Term Loan' },
  ];

  sanctionLoanForm: FormGroup | any;
  shgLoanId: string = '';
  maxDate: Date = new Date();
  minDate: Date = new Date();
  dateFilter: any;

  constructor(
    private dialogRef: MatDialogRef<SanctionLoanDialogueComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private bankService: BankService,
    private route: Router
  ) {
    this.createSanctionLoanForm();
  }

  ngOnInit(): void {
    const today = new Date();
    this.maxDate = today;

    // Set minDate based on submissionDate
    if (this.data?.submissionDate) {
      const previousDate = this.getPreviousDate(this.data?.submissionDate);
      this.minDate = new Date(previousDate);

    } else {
      this.minDate = new Date();
    }

    this.shgLoanId = this.data?.shgLoanId;
    this.updateValidation();

    // Updated Date Filter Logic
    this.dateFilter = (date: Date | null): boolean => {
      const selectedDate = date || new Date();
      const todayStr = today.toDateString();
      const minDateStr = this.minDate.toDateString();
      const maxDateStr = this.maxDate.toDateString();
      const selectedDateStr = selectedDate.toDateString();

      // Allow today's date
      if (selectedDateStr === todayStr) {
        return true;
      }

      // Enable all dates between minDate and maxDate
      return selectedDate >= this.minDate && selectedDate <= this.maxDate;
    };

    this.sanctionLoanForm
      .get('sanctionDate')
      ?.valueChanges.subscribe((selectedDate: Date) => {
        if (selectedDate) {
          const dateWithCurrentTime =
            this.combineDateWithCurrentTime(selectedDate);
          // Use `patchValue` to avoid triggering valueChanges infinitely
          this.sanctionLoanForm
            .get('sanctionDate')
            ?.patchValue(dateWithCurrentTime, { emitEvent: false });
        }
      });
  }

  getPreviousDate(inputDate: string): string {
    const date = new Date(inputDate);
    date.setDate(date.getDate() - 1);
    return (
      date.toISOString().replace('T', ' ').replace('Z', '').slice(0, -3) + '000'
    );
  }

  combineDateWithCurrentTime(selectedDate: Date): Date {
    const currentDate = new Date(); // Get current date and time
    selectedDate.setHours(currentDate.getHours());
    selectedDate.setMinutes(currentDate.getMinutes());
    selectedDate.setSeconds(currentDate.getSeconds());
    selectedDate.setMilliseconds(currentDate.getMilliseconds());

    return selectedDate;
  }

  createSanctionLoanForm() {
    return (this.sanctionLoanForm = this._formBuilder.group({
      loanType: ['', Validators.required],
      loanAccountNumber: ['', Validators.required],
      sanctionAmount: ['', [Validators.required, Validators.max(2000000)]],
      sanctionDate: [
        '',
        [Validators.required, this.dateRangeValidator.bind(this)],
      ],
      interestRate: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{1,2}(\.\d{1,2})?$/),
          Validators.min(0),
          Validators.max(99.99),
        ],
      ],
      dpLimit: [''],
      installmentNumber: [''],
      emi: [''],
      disbursedAmount: [''],
    }));
  }

  // Custom validator for date range
  dateRangeValidator(control: FormControl) {
    const selectedDate = new Date(control.value);
    const min = new Date(this.minDate);
    const max = new Date(this.maxDate);

    // Allow selection of today's date
    const today = new Date();
    if (selectedDate.toDateString() === today.toDateString()) {
      return null; // Valid if selected date is today
    }

    // Check if selectedDate is within range
    if (selectedDate < min || selectedDate > max) {
      return { dateOutOfRange: true };
    }
    return null;
  }

  updateValidation() {
    this.sanctionLoanForm
      .get('loanType')
      .valueChanges.subscribe((loanType: number) => {
        if (loanType === 1) {
          this.sanctionLoanForm.patchValue({
            disbursedAmount: '',
            installmentNumber: '',
            emi: '',
          });
        }
      });
  }

  submitsanctionLoan(data: any) {
    // console.log('Data: ', this.data);
    // console.log('Sanction Form: ', this.sanctionLoanForm);

    let payload: any = {
      shgLoanId: +this.shgLoanId,
      ...this.sanctionLoanForm.value,
    };

    // console.log('Payload: ', payload);

    this.bankService.sanctionLoan(payload).subscribe(
      (res: any) => {
        if (res?.responseCode == 200) {
          this.openSnackBar(res.responseDesc);
          this.dialogRef.close(true);
          this.route.navigate(['/admin/sanction']);
        }
      },
      (error: any) => {
        // console.log('Error: ', error);

        // this.openSnackBar(error.errorMsg, 'Close', true);
      }
    );
    // console.log('Returned Reason Form: ', this.data, this.sanctionLoanForm);
  }

  openSnackBar(message: any, action = '', isError: boolean = false) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [
        isError ? 'error-snackbar' : 'success-snackbar',
        'centered-snackbar',
      ],
    });
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
